<template>
  <div class="operation-item">
    <block-title title="下载模板">
      <a-row class="exportStyle item-content">
        <template v-if="!isWmsSystem">
          <a-col :span="11" :offset="0">
            <div
              :class="
                typeIndex === WAREHOUSETYPE.ORDER_RULE
                  ? 'radioBox radioBoxActive'
                  : 'radioBox'
              "
              @click="editTypeIndex(WAREHOUSETYPE.ORDER_RULE)"
            >
              <img
                v-if="typeIndex === WAREHOUSETYPE.ORDER_RULE"
                class="activeImg"
                src="@/assets/img/icon_select.png"
                alt=""
              />
              <p class="exportTitle">纯运输下单</p>
              <!-- <a-radio class="exportTitle" :checked="typeIndex === WAREHOUSETYPE.ORDER_RULE ? true : false">纯仓储下单</a-radio> -->
              <p class="skuStyle">表格支持干线专车计费方式的下单</p>
              <div
                v-track-click="{
                  trackName: $route.query.menuName
                    ? `${$route.query.menuName}-批量导入下单-下载模板-纯运输下单导入模板`
                    : `批量导入下单-下载模板-纯运输下单导入模板`,
                }"
                class="batchBtnStyle"
                @click="
                  downloadExcelTransport('纯运输下单导入模板', WAREHOUSETYPE.ORDER_RULE)
                "
              >
                <img src="@/assets/img/icon/xlsx.png" />
                纯运输下单导入模板
                <img
                  class="icon_load"
                  :src="
                    typeIndex === WAREHOUSETYPE.ORDER_RULE ? downloadField : downloads
                  "
                />
              </div>
            </div>
          </a-col>
          <a-col class="leftStyle" :span="11" :offset="0">
            <div
              :class="
                typeIndex === WAREHOUSETYPE.TRANSPORT
                  ? 'radioBox radioBoxActive'
                  : 'radioBox'
              "
              @click="editTypeIndex(WAREHOUSETYPE.TRANSPORT)"
            >
              <img
                v-if="typeIndex === WAREHOUSETYPE.TRANSPORT"
                class="activeImg"
                src="@/assets/img/icon_select.png"
                alt=""
              />
              <p class="exportTitle">仓配一体下单</p>
              <!-- <a-radio class="exportTitle" :checked="typeIndex === WAREHOUSETYPE.TRANSPORT ? true : false">仓配一体下单</a-radio> -->
              <p class="skuStyle">出库与运输一体下单</p>
              <div
                v-track-click="{
                  trackName: $route.query.menuName
                    ? `${$route.query.menuName}-批量导入下单-下载模板-仓配一体下单导入模板`
                    : `批量导入下单-下载模板-仓配一体下单导入模板`,
                }"
                class="batchBtnStyle"
                @click="
                  downloadTemplate(
                    '仓配一体下单导入模板',
                    WAREHOUSETYPE.DELIVER_TRANSPORT_V2,
                    true
                  )
                "
              >
                <img src="@/assets/img/icon/xlsx.png" />
                仓配一体下单导入模板
                <img
                  class="icon_load"
                  :src="typeIndex === WAREHOUSETYPE.TRANSPORT ? downloadField : downloads"
                />
              </div>
<!--              <div v-else class="flex justify-between" style="margin-top: 11px">-->
<!--                <div-->
<!--                  v-track-click="{-->
<!--                    trackName: $route.query.menuName-->
<!--                      ? `${$route.query.menuName}-批量导入下单-下载模板-仓配一体入库单模板`-->
<!--                      : `批量导入下单-下载模板-仓配一体入库单模板`,-->
<!--                  }"-->
<!--                  :class="{ batchBtn: true, isActive: type === WAREHOUSETYPE.STORE }"-->
<!--                  @click="changeType(WAREHOUSETYPE.STORE)"-->
<!--                >-->
<!--                  仓配一体入库-->
<!--                  <img-->
<!--                    class="icon_load"-->
<!--                    :src="-->
<!--                      typeIndex === WAREHOUSETYPE.TRANSPORT &&-->
<!--                      type === WAREHOUSETYPE.STORE-->
<!--                        ? downloadField-->
<!--                        : downloads-->
<!--                    "-->
<!--                    @click="downloadTemplate('仓配一体入库', WAREHOUSETYPE.STORE, true)"-->
<!--                  />-->
<!--                </div>-->
<!--                <div-->
<!--                  v-track-click="{-->
<!--                    trackName: $route.query.menuName-->
<!--                      ? `${$route.query.menuName}-批量导入下单-下载模板-仓配一体出库单模板`-->
<!--                      : `批量导入下单-下载模板-仓配一体出库单模板`,-->
<!--                  }"-->
<!--                  :class="{ batchBtn: true, isActive: type === WAREHOUSETYPE.DELIVER }"-->
<!--                  @click="changeType(WAREHOUSETYPE.DELIVER)"-->
<!--                >-->
<!--                  仓配一体出库-->
<!--                  <img-->
<!--                    class="icon_load"-->
<!--                    :src="-->
<!--                      typeIndex === WAREHOUSETYPE.TRANSPORT &&-->
<!--                      type === WAREHOUSETYPE.DELIVER-->
<!--                        ? downloadField-->
<!--                        : downloads-->
<!--                    "-->
<!--                    @click="downloadTemplate('仓配一体出库', WAREHOUSETYPE.DELIVER, true)"-->
<!--                  />-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </a-col>
          <a-col style="margin-top: 20px;" :span="11" :offset="0">
            <div
              :class="
                typeIndex === WAREHOUSETYPE.WAREHOUSE
                  ? 'radioBox radioBoxActive'
                  : 'radioBox'
              "
              @click="editTypeIndex(WAREHOUSETYPE.WAREHOUSE)"
            >
              <img
                v-if="typeIndex === WAREHOUSETYPE.WAREHOUSE"
                class="activeImg"
                src="@/assets/img/icon_select.png"
                alt=""
              />
              <p class="exportTitle">仓下单</p>
              <!-- <a-radio class="exportTitle" :checked="typeIndex === WAREHOUSETYPE.WAREHOUSE ? true : false">纯仓储下单</a-radio> -->
              <p class="skuStyle">运输入库、纯入库、纯出库</p>
              <div class="flex justify-between">
                <div
                  v-track-click="{
                    trackName: $route.query.menuName
                      ? `${$route.query.menuName}-批量导入下单-下载模板-仓入库单模板`
                      : `批量导入下单-下载模板-仓入库单模板`,
                  }"
                  :class="{ batchBtn: true, isActive: type === WAREHOUSETYPE.STORE_V2 }"
                  @click="changeType(WAREHOUSETYPE.STORE_V2)"
                >
                  仓入库单模版
                  <img
                    class="icon_load"
                    :src="
                      typeIndex === WAREHOUSETYPE.WAREHOUSE &&
                      type === WAREHOUSETYPE.STORE_V2
                        ? downloadField
                        : downloads
                    "
                    @click="downloadTemplate('仓入库单模版', WAREHOUSETYPE.STORE_V2, true)"
                  />
                </div>
                <div
                  v-track-click="{
                    trackName: $route.query.menuName
                      ? `${$route.query.menuName}-批量导入下单-下载模板-仓出库单模板`
                      : `批量导入下单-下载模板-仓出库单模板`,
                  }"
                  :class="{ batchBtn: true, isActive: type === WAREHOUSETYPE.DELIVER_ONLY_V2 }"
                  @click="changeType(WAREHOUSETYPE.DELIVER_ONLY_V2)"
                >
                  仓出库单模板
                  <img
                    class="icon_load"
                    :src="
                      typeIndex === WAREHOUSETYPE.WAREHOUSE &&
                      type === WAREHOUSETYPE.DELIVER_ONLY_V2
                        ? downloadField
                        : downloads
                    "
                    @click="downloadTemplate('仓出库单模板', WAREHOUSETYPE.DELIVER_ONLY_V2, true)"
                  />
                </div>
              </div>
            </div>
          </a-col>
          <a-col style="margin-top: 20px;" class="leftStyle" :span="11" :offset="0">
            <div
              :class="typeIndex === 'PLAN_ORDER' ? 'radioBox radioBoxActive' : 'radioBox'"
              @click="editTypeIndex('PLAN_ORDER')"
            >
              <img
                v-if="typeIndex === 'PLAN_ORDER'"
                class="activeImg"
                src="@/assets/img/icon_select.png"
                alt=""
              />
              <p class="exportTitle">仓配出库计划单</p>
              <p class="skuStyle">仓配一体计划单下发WMS进行任务确认</p>
              <div
                v-track-click="{
                  trackName: $route.query.menuName
                    ? `${$route.query.menuName}-批量导入下单-下载模板-仓配出库计划单`
                    : `批量导入下单-下载模板-仓配出库计划单`,
                }"
                class="batchBtnStyle"
                @click="downloadExcelWareHouseTransport('仓配出库计划单', 'PLAN_ORDER')"
              >
                <img src="@/assets/img/icon/xlsx.png" />
                仓配出库计划单
                <img
                  class="icon_load"
                  :src="typeIndex === 'PLAN_ORDER' ? downloadField : downloads"
                />
              </div>
            </div>
          </a-col>
        </template>
        <wmsWarehouseMultiple
          v-else
          :type-index="typeIndex"
          @downloadExcelWareHouse="downloadExcelWareHouse"
          @downloadExcelWareHouseTransport="downloadExcelWareHouseTransport"
          @editTypeIndex="editTypeIndex"
          @downloadTemplate="downloadTemplate"
          @changeWareHouseType="changeType"
        />
         <a-col v-if="nonOperating" :span="11" class="leftStyle product-flg" :offset="0">
          <div
            :class="typeIndex === UPLOADTYPE.SETTLEMENT ? 'radioBox radioBoxActive' : 'radioBox'"
            @click="editTypeIndex(UPLOADTYPE.SETTLEMENT)"
          >
            <img v-if="typeIndex === UPLOADTYPE.SETTLEMENT" class="activeImg" src="@/assets/img/icon_select.png" alt="">
            <p class="exportTitle">结算订单专用模板导入</p>
            <p class="skuStyle">
              表格中填写货品品类，不填写sku明细
            </p>
            <div class="batchBtnStyle" @click="downloadExcelTemplate(TEMPLATETYPE.SETTLEMENT, TEMPLATETYPE.SETTLEMENT.type)">
              <img src="@/assets/img/icon/xlsx.png" />
              批量下单模板（结算订单专用模板）
              <img class="icon_load" :src="typeIndex === UPLOADTYPE.SETTLEMENT ? downloadField : downloads" />
            </div>
          </div>
        </a-col>
        <a-col v-if="isSeaShipping" :span="11" class="leftStyle product-flg" :offset="0">
          <div
            :class="typeIndex === UPLOADTYPE.SETTLEMENT_SEA_TRANSPORT ? 'radioBox radioBoxActive' : 'radioBox'"
            @click="editTypeIndex(UPLOADTYPE.SETTLEMENT_SEA_TRANSPORT)"
          >
            <img v-if="typeIndex === UPLOADTYPE.SETTLEMENT_SEA_TRANSPORT" class="activeImg" src="@/assets/img/icon_select.png" alt="">
            <p class="exportTitle">海运订单导入</p>
            <p class="skuStyle">
              表格支持海运订单的方式下单
            </p>
            <div class="batchBtnStyle" @click="downloadExcelTemplate(TEMPLATETYPE.SETTLEMENT_SEA_TRANSPORT, TEMPLATETYPE.SETTLEMENT_SEA_TRANSPORT.type)">
              <img src="@/assets/img/icon/xlsx.png" />
              批量下单模板（使用海运订单模板）
              <img class="icon_load" :src="typeIndex === UPLOADTYPE.SETTLEMENT_SEA_TRANSPORT ? downloadField : downloads" />
            </div>
          </div>
        </a-col>
        <a-col v-if="isSupplementary" :span="11" class="leftStyle product-flg" :offset="0">
          <div
            :class="typeIndex === UPLOADTYPE.MULTISTAGE_SETTLEMENT ? 'radioBox radioBoxActive' : 'radioBox'"
            @click="editTypeIndex(UPLOADTYPE.MULTISTAGE_SETTLEMENT)"
          >
            <img v-if="typeIndex === UPLOADTYPE.MULTISTAGE_SETTLEMENT" class="activeImg" src="@/assets/img/icon_select.png" alt="">
            <p class="exportTitle">补录订单导入专用</p>
            <p class="skuStyle">
              表格支持补录订单导入专用下单
            </p>
            <div class="batchBtnStyle" @click="downloadExcelTemplate(TEMPLATETYPE.MULTISTAGE_SETTLEMENT, TEMPLATETYPE.MULTISTAGE_SETTLEMENT.type)">
              <img src="@/assets/img/icon/xlsx.png" />
              批量下单模板（使用补录订单专用模板）
              <img class="icon_load" :src="typeIndex === UPLOADTYPE.MULTISTAGE_SETTLEMENT ? downloadField : downloads" />
            </div>
          </div>
        </a-col>
        <a-col v-if="nonOperating && isSettlement" :span="11" class="leftStyle product-flg" :offset="0">
          <div
            :class="typeIndex === UPLOADTYPE.SETTLEMENT_PRICE ? 'radioBox radioBoxActive' : 'radioBox'"
            @click="editTypeIndex(UPLOADTYPE.SETTLEMENT_PRICE)"
          >
            <img v-if="typeIndex === UPLOADTYPE.SETTLEMENT_PRICE" class="activeImg" src="@/assets/img/icon_select.png" alt="">
            <div class="flex justify-between align-center">
              <p class="exportTitle">结算订单专用模板导入</p>
              <span class="tips">自定义应收应付</span>
            </div>
            <p class="skuStyle">
              表格中填写货品品类，不填写sku明细
            </p>
            <div class="batchBtnStyle" @click="downloadExcelTemplate(TEMPLATETYPE.SETTLEMENT_PRICE, TEMPLATETYPE.SETTLEMENT_PRICE.type)">
              <img src="@/assets/img/icon/xlsx.png" />
              批量下单模板（结算订单专用模板）
              <img class="icon_load" :src="typeIndex === UPLOADTYPE.SETTLEMENT_PRICE ? downloadField : downloads" />
            </div>
          </div>
        </a-col>
      </a-row>
    </block-title>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BlockTitle from '@/components/panel/BlockTitle.vue';
import downloadField from '@/assets/img/icon/download_field.png';
import downloads from '@/assets/img/icon/download.png';
import {WAREHOUSETYPE, TEMPLATEURL, UPLOADTYPE, TEMPLATETYPE, UsualToBusiness} from './multipleConst';
import wmsWarehouseMultiple from './wmsWarehouseMultiple/index.vue';

export default {
  name: 'WarehouseMultiple',
  components: {
    BlockTitle,
    wmsWarehouseMultiple,
  },
  props: {
    typeIndex: {
      type: String,
      default: '',
    },
    isDischarge: {
      type: Boolean,
      default: false,
    },
    isWmsSystem: {
      type: Boolean,
      default: false,
    },
    nonOperating: {
      type: Boolean,
      default: false
    },
    hasWarehouseContract: {
      type: Boolean,
      default: false
    },
    isSeaShipping: {
      type: Boolean,
      default: false
    },
    isSupplementary: {
      type: Boolean,
      default: false
    },
    isSettlement: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      UPLOADTYPE,
      TEMPLATETYPE,
      WAREHOUSETYPE,
      downloadField,
      downloads,
      type: WAREHOUSETYPE.STORE,
    };
  },
  watch: {
    typeIndex(newVal) {
      if(newVal === 'WAREHOUSE_TRANSPORT') {
        this.changeType(WAREHOUSETYPE.DELIVER_TRANSPORT_V2)
      }else {
        this.changeType(WAREHOUSETYPE.STORE_V2)
      }
    },
  },
  computed:{
    ...mapGetters('orderRules', ['isOrderDemoVersion']),
  },
  methods: {
    downloadExcelWareHouse(item, type) {
      this.$emit('downloadExcelWareHouse', item, type)
    },
    downloadXls(url, name) {
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    downloadExcelTemplate(item, index) {
      this.$emit('downloadExcelTemplate', item, index)
    },
    downloadExcelTransport(item) {
      // this.downloadXls('/xls/pureTransport.xlsx', item);
      this.$emit('downloadDetails',item, TEMPLATEURL.EXCEL_TEMPLATE, 'STANDARD_PRODUCT_V2')
    },
    downloadExcelWareHouseTransport(item, type) {
      this.$emit('downloadExcelWareHouseTransport', item, type);
    },
    editTypeIndex(index) {
      this.$emit('editTypeIndex', index);
    },
    downloadTemplate(item, type, isTransport) {
      const innerType = this.isOrderDemoVersion? type : (UsualToBusiness[type]||type)
      this.$emit('downloadTemplate', item, innerType, isTransport);
    },
    changeType(type) {
      this.type = type;
      this.$emit('changeWareHouseType', type);
    },
  },
};
</script>

<style lang="less" scoped>
.icon_load {
  width: 24px;
  height: 24px;
}
.radioBox {
  height: 229px;

  .justify-between {
    .batchBtn {
      background: #f2fbf8;
      border-radius: 4px;
      padding: 10px;
      min-height: 68px;
      color: #06b880;
      border: 1px dashed #ebe8e8;
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &:last-of-type {
        margin-left: 10px;
      }

      &:hover {
        border: 1px dashed #06b880;
      }
    }
  }

  &.radioBoxActive {
    .justify-between {
      .batchBtn {
        &.isActive {
          border: 1px dashed #06b880;
        }
      }
    }
  }
}
</style>
